
export interface ProtokollInfo {
  protokollTyp: number[]
}

export class ProtokollStore {

  public static getDataSet( store: any) : ProtokollInfo {
    console.log(store.getters["protokollstore/getDataSet"])
    return store.getters["protokollstore/getDataSet"];
  
  }

  public static setDataSet( store: any, payload: ProtokollInfo) {
    store.commit("protokollstore/setDataSet" , payload)
  }

}

export const protokollstore = {
  namespaced: true,
  state: {
    protokollInfo: {
      protokollTyp: [],
    }
  },
  mutations: {
    setDataSet(state: any, payload: ProtokollInfo) {
      state.protokollInfo = payload;
    }
  },
  actions: {},
  getters: {
    getDataSet: function(state: any): ProtokollInfo {
      return state.protokollInfo;
    }
  }
};

// type Areas
// this._store.getters["areastore/getDataSet"]
// _store.commit("areastore/addDataSet", areaInfo)